import { render } from "./ProductWrapper.vue?vue&type=template&id=539194dc&scoped=true"
import script from "./ProductWrapper.vue?vue&type=script&lang=js"
export * from "./ProductWrapper.vue?vue&type=script&lang=js"

import "./ProductWrapper.vue?vue&type=style&index=0&id=539194dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539194dc"]])

export default __exports__